import * as Types from './orderActionTypes.js'

const initialState = {
    productionOrders: [],
    materials: [],
    articles: [],
    refreshOrders: false,
    finishedOrderIds: []
};

export default function order(state = initialState, action) {
    switch (action.type) {
        case Types.SET_PRODUCTIONORDERS:
            if (state.productionOrders !== action.productionOrders) {
                return Object.assign({}, state, { productionOrders: action.productionOrders });
            }
            return state;
        case Types.SET_MATERIALS:
            if (state.materials !== action.materials) {
                return Object.assign({}, state, { materials: action.materials });
            }
            return state;
        case Types.SET_ARTICLES:
            if (state.articles !== action.articles) {
                return Object.assign({}, state, { articles: action.articles });
            }
            return state;
        case Types.SET_FINISHEDORDERIDS:
            if (state.finishedOrderIds !== action.finishedOrderIds) {
                return Object.assign({}, state, { finishedOrderIds: action.finishedOrderIds });
            }
            return state;
        case Types.REFRESH_ORDERS:
            if (state.refreshOrders !== action.refreshOrders) {
                return Object.assign({}, state, { refreshOrders: action.refreshOrders });
            }
            return state;
        default:
            return state;
    }
}